import { render } from "./page16.vue?vue&type=template&id=346c4d76&scoped=true"
import script from "./page16.vue?vue&type=script&lang=js"
export * from "./page16.vue?vue&type=script&lang=js"

import "./page16.vue?vue&type=style&index=0&id=346c4d76&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-346c4d76"]])

export default __exports__